//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TASH_info'

}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Anae/TASH_info.vue